'use client';

import { useEffect } from 'react';
import { useTripChatContext } from '../contexts/TripChatContext';
import type { PageContext } from './TripChat';

/**
 * Invisible client component that sets TripChat page context.
 * Render from server pages to give TripChat contextual awareness.
 *
 * Usage:
 *   <SetTripChatContext pageType="campsite" entityId={42} entityName="Big River Camp" />
 */
export default function SetTripChatContext(props: PageContext) {
  const { setPageContext } = useTripChatContext();

  useEffect(() => {
    setPageContext(props);
    return () => setPageContext(undefined);
  }, [props.pageType, props.entityId, props.entityName, props.bookingUrl, props.productType, props.productName, setPageContext]);

  return null;
}
